import { graphql } from '@shared/api/gql';

// Shared by daily and starmagazine (improvements/07-template-architecture.md's
// reader-family collapse) -- field-for-field identical, differing only in
// the GraphQL operation name (a client-side debug label). Kept as
// `GetFeedIssueGamesDaily`'s exact text rather than renamed, since
// `graphql()`'s codegen'd `Documents` map is keyed by exact query string and
// renaming would need a codegen re-run (same reasoning as Section.document.ts).
export const feedQueryDocument = graphql(`
	query GetFeedIssueGamesDaily($id: ID!, $sortKey: ArticleSortKeys, $reverse: Boolean) {
		issue(id: $id) {
			id
			name
			slug
			articles(sortKey: $sortKey, reverse: $reverse) {
				id
				name
				ArticleID
				created
				updated
				releaseDate
				thumbnail
				featureImage
				slug
				description
			}
		}
	}
`);
